import { render } from "./CreateTemplateModal.vue?vue&type=template&id=44ed6b31"
import script from "./CreateTemplateModal.vue?vue&type=script&lang=js"
export * from "./CreateTemplateModal.vue?vue&type=script&lang=js"

import "./CreateTemplateModal.vue?vue&type=style&index=0&id=44ed6b31&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__